import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import PrivateRoute from "./PrivateRouteWrapper";
import publicRoutes from "./publicRoutes";
import privateRoutes from "./privateRoutes";
import PrivateRouteContainer from "./PrivateRouteContainer";

const NotFound = lazy(() => import("../pages/ServicePages/NotFound"));

export const router = createBrowserRouter([
  ...publicRoutes,
  {
    element: <PrivateRoute element={<PrivateRouteContainer />} />,
    children: privateRoutes,
  },
  { path: "*", element: <NotFound /> },
]);
